import { render, staticRenderFns } from "./CategoriesAmbassador.vue?vue&type=template&id=e92173c2&scoped=true"
import script from "./CategoriesAmbassador.vue?vue&type=script&lang=ts"
export * from "./CategoriesAmbassador.vue?vue&type=script&lang=ts"
import style0 from "./CategoriesAmbassador.vue?vue&type=style&index=0&id=e92173c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92173c2",
  null
  
)

export default component.exports